"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOB_NAMES = exports.QUEUE_NAMES = exports.ACCOUNTING_SYNC_LOG_PREFIX = void 0;
/** Shared log prefix — grep `accounting-sync` across client-api, business-api, and worker. */
exports.ACCOUNTING_SYNC_LOG_PREFIX = "[accounting-sync]";
exports.QUEUE_NAMES = {
    workerHealthCheck: "worker-health-check",
    /** Xero accounting BullMQ queue: failed-row batch retry + allocate payment after escrow/instant release. */
    accountingSync: "accounting-sync",
    /** Canonical payment provider reconciliation (Finmo → provider_* tables). */
    paymentReconciliation: "payment-reconciliation",
    recurringInvoices: "recurring-invoices",
    /** General Mailjet send queue (PDF completion emails first; extensible by job name). */
    mailjetEmail: "mailjet-email",
    /** Lead magnet. Registered with no processors until the delivery, alert, sheet, and DD tickets. */
    leadRenderPdf: "render-pdf",
    leadDeliverDocument: "deliver-document",
    leadAlerts: "alerts",
    leadSheetSync: "sheet-sync",
    leadDdReport: "dd-report",
};
exports.JOB_NAMES = {
    workerHealthCheckPublish: "worker-health-check-publish",
    /** Cron / manual: scan FAILED Xero invoice sync rows and retry. */
    accountingFailedInvoiceSyncRetryRun: "accounting-sync-retry-failed",
    /** After escrow release: POST Xero Payment against existing ACCREC. */
    accountingSyncAllocatePayment: "accounting-sync-allocate-payment",
    /** After Handshake revision accept: create / reconcile / void ACCRECs. */
    accountingSyncAfterRevision: "accounting-sync-after-revision",
    /** Cron / event: reconcile provider payment state into canonical tables. */
    paymentReconciliationRun: "payment-reconciliation-run",
    recurringInvoiceGenerate: "recurring-invoice-generate",
    scheduledInvoiceReminderSend: "scheduled-invoice-reminder-send",
    kybReviewTimeoutCheck: "kyb-review-timeout-check",
    dailyDigestSend: "daily-digest-send",
    invoicesDueTodayDigestSend: "invoices-due-today-digest-send",
    monthlyFinancialDigestSend: "monthly-financial-digest-send",
    /** Project completion emails with PDF attachments (business and/or client). */
    mailjetTransactionCompleted: "mailjet-transaction-completed",
    /** Cron: re-enqueue completion emails for COMPLETED projects with pending metadata (HAN-551). */
    mailjetCompletionEmailRetryRun: "mailjet-completion-email-retry",
};
